import React from 'react';

const SORT_OPTIONS = [
    {value: 'best_sellers', label: 'Best Sellers'},
    {value: 'price_asc', label: 'Price: Low to High'},
    {value: 'price_desc', label: 'Price: High to Low'},
    {value: 'newest', label: 'Newest'},
] as const;

export type SortValue = (typeof SORT_OPTIONS)[number]['value'];

interface SortDropdownProps {
    value: SortValue;
    onChange: (value: SortValue) => void;
}

const SortDropdown: React.FC<SortDropdownProps> = ({value, onChange}) => {
    return (
        <select
            value={value}
            onChange={(e) => onChange(e.target.value as SortValue)}
            className="border border-gray-300 rounded-lg px-3 py-2 text-sm bg-mld-menu-background text-mld-menu-text focus:outline-none focus:ring-2 focus:ring-mld-primary/50">
            {SORT_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                    {opt.label}
                </option>
            ))}
        </select>
    );
};

export default SortDropdown;
